// extracted by mini-css-extract-plugin
module.exports = {"profilePictureContainer":"profilePicture_profilePictureContainer__Kn2_o","avatarImage":"profilePicture_avatarImage__No37j"};